import { t } from "@/i18n-js/instance";

import type { DirectUploadStatus } from "../../types";

export const getFileUploadCtaByStatus = (): Record<
  DirectUploadStatus,
  string
> => ({
  idle: t("emoji_picker_v3.custom_icon.file_upload.cta"),
  uploading: t("emoji_picker_v3.custom_icon.cta_uploading"),
  completed: t("emoji_picker_v3.custom_icon.cta_completed"),
  error: t("emoji_picker_v3.custom_icon.file_upload.cta"),
});
